export * from './job-card-acceptance.component';